var BookmarkView, BookmarksView, CollectionView, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

CollectionView = require('./base/collection-view');

BookmarkView = require('./bookmark-view');

template = require('./templates/bookmarks');

module.exports = BookmarksView = (function(_super) {
  __extends(BookmarksView, _super);

  function BookmarksView() {
    _ref = BookmarksView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  BookmarksView.prototype.template = template;

  BookmarksView.prototype.itemView = BookmarkView;

  BookmarksView.prototype.autoRender = true;

  BookmarksView.prototype.listSelector = '#bookmarks-list';

  BookmarksView.prototype.itemSelector = '.item';

  return BookmarksView;

})(CollectionView);
